import { faSliders } from "@fortawesome/pro-regular-svg-icons/faSliders";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Tab } from "@mui/material";
import { MprcBarTabs, MprcLink, MprcText } from "components";
import { MprcCardFilterBox } from "components/filter/MprcCardFilterBox";
import React from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { RootPaths } from "routes/RootRouter";

/////////////////////////////////////////////////////////////////////////////////////////////////

export const GlobalSearchFirstPageRowsPerPage = 5;

export const GlobalSearchRowsPerPage = 20;

export type SearchTab = "All" | "Knowledge" | "Videos" | "Documents" | "Trainings";

export type TabOptions = {
    hasAll: boolean;
    hasVideos: boolean;
    hasDocuments: boolean;
    hasTrainings: boolean;
};

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    selectedTab: SearchTab;
    tabOptions: TabOptions;
}

export const FullGlobalSearchTabs = ({ selectedTab, tabOptions }: IProps) => {
    const { t } = useTranslation("shared");
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <MprcCardFilterBox>
            <Grid container justifyContent="center" alignItems="center">
                <Grid>
                    <MprcBarTabs value={selectedTab} size="medium">
                        {
                            tabOptions.hasAll &&
                            <Tab label={t("GlobalSearch.Tabs.All")} value="All" onClick={() => navigate(RootPaths.BuildSearchTab(), { state: location.state })} />
                        }
                        {
                            tabOptions.hasVideos &&
                            <Tab label={t("GlobalSearch.Tabs.Videos")} value="Videos" onClick={() => navigate(RootPaths.BuildSearchTab("Videos"), { state: location.state })} />
                        }
                        {
                            tabOptions.hasDocuments &&
                            <Tab label={t("GlobalSearch.Tabs.Documents")} value="Documents" onClick={() => navigate(RootPaths.BuildSearchTab("Documents"), { state: location.state })} />
                        }
                        {
                            tabOptions.hasTrainings &&
                            <Tab label={t("GlobalSearch.Tabs.Trainings")} value="Trainings" onClick={() => navigate(RootPaths.BuildSearchTab("Trainings"), { state: location.state })} />
                        }
                    </MprcBarTabs>
                </Grid>
                <Grid size="grow">
                    <div id="SearchTabButtonOptions"></div>
                </Grid>
            </Grid>

            <div id="SearchTabFilterOptions"></div>

        </MprcCardFilterBox>
    );
};

/////////////////////////////////////////////////////////////////////////////////////////////////

export const FullGlobalSearchOptionsLine = ({ filterOpened, filter, el }: { filterOpened: boolean; filter: React.ReactNode; el: HTMLElement | null; }) => {
    return filterOpened && el
        ? ReactDOM.createPortal(filter, el)
        : null;
};

/////////////////////////////////////////////////////////////////////////////////////////////////

export const FullGlobalSearchButtonOptions = ({ filtering, onFilterClick }: { filtering: boolean; onFilterClick: () => void; }) => {
    var el = document.getElementById("SearchTabButtonOptions") as HTMLElement;

    return el
        ? ReactDOM.createPortal(
            <MprcLink onClick={onFilterClick}>
                <MprcText color={filtering ? "warning" : "inherit"}>
                    <FontAwesomeIcon icon={faSliders} fixedWidth fontSize={22} />
                </MprcText>
            </MprcLink>
            , el)
        : null;
};


/////////////////////////////////////////////////////////////////////////////////////////////////
